import { render } from "./AttrItem.vue?vue&type=template&id=35e4f792"
import script from "./AttrItem.vue?vue&type=script&lang=js"
export * from "./AttrItem.vue?vue&type=script&lang=js"

import "./AttrItem.vue?vue&type=style&index=0&id=35e4f792&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__